export const isValidEmailAddress = (email = '') => {
  // eslint-disable-next-line no-useless-escape
  return /^(([A-Za-z0-9]+_+)|([A-Za-z0-9]+\-+)|([A-Za-z0-9]+\.+)|([A-Za-z0-9]+\++))*[A-Za-z0-9]+@((\w+\-+)|(\w+\.))*\w{1,63}\.[a-zA-Z]{2,}$/.test(
    email,
  );
};

export const isValidUrl = (url) => {
  const pattern =
    /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\\.-]+)+[\w\-\\._~:\\/?#[\]@!\\$&'\\(\\)\\*\\+,;=.]+$/;
  const isValid = pattern.test(url);
  return isValid ? undefined : 'Invalid URL';
};

export const isEmptyOrValidUrl = (url = '') => {
  if (url.trim()) {
    return isValidUrl(url);
  }
};

export const isDecimalRange =
  (min = -Infinity, max = Infinity, allowNull = false) =>
  (value) => {
    if (allowNull && !value) {
      return undefined;
    }
    if (!/^[1-9]\d*([\.]\d{1,2})?$/.test(`${value}`)) {
      return 'Invalid value';
    }
    const float = parseFloat(value);
    if (float < min) {
      return `The value should be greater or equal to ${min}`;
    }
    if (float > max) {
      return `The value should be less or equal to ${max}`;
    }
  };

export const isIntInRange =
  (min = -Infinity, max = Infinity, allowNull = false) =>
  (value) => {
    if (allowNull && !value) {
      return undefined;
    }
    if (!/^[0-9]+$/.test(`${value}`)) {
      return 'Invalid value';
    }
    const integer = parseInt(value, 10);
    if (integer < min) {
      return `The value should be greater or equal to ${min}`;
    }
    if (integer > max) {
      return `The value should be less or equal to ${max}`;
    }
  };

export const required = (value) =>
  value !== null && value !== undefined && value !== '' ? undefined : 'Required';

export const requiredIf = (condition) => (value) => {
  if (!condition) {
    return undefined;
  }
  return value !== null && value !== undefined && value !== '' ? undefined : 'Required';
};

export const requiredWithRangeFilters = (value) =>
  value && value.value && value.intervalType ? undefined : 'Required';

export const requiredWithZeroAsValid = (value) => (value || value === 0 ? undefined : 'Required');

export const arrayNotEmpty = (values = []) => (values.length > 0 ? undefined : 'Required');

export const composeValidators =
  (...validators) =>
  (value) =>
    validators.reduce((error, validator) => error || validator(value), undefined);

export const parseEmptyValuesToNull = (value) => (value === '' ? null : value);

export const isValidOpportunityId = (value) => {
  if (!value) {
    return undefined;
  }
  if (value.length === 0) {
    return undefined;
  }
  if (value.length === 18) {
    return undefined;
  }
  return 'Invalid opportunity id, it should look like 0065B00000CkRTZQA3';
};

export const requiredEmailList = (values = []) => {
  if (!values.length) {
    return 'Required';
  }
  const invalidEmails = values.filter((value) => !isValidEmailAddress(value.email || value));
  if (invalidEmails.length > 0) {
    return `Email address is not valid`;
  }
  return undefined;
};

export const validateEmail = (value = '') => {
  if (!value) {
    return undefined;
  }
  // check for array
  if (Array.isArray(value)) {
    const invalidEmails = value.filter((item) => {
      const email = item.email ? item.email.trim() : item.trim();
      return !isValidEmailAddress(email);
    });
    if (invalidEmails.length > 0) {
      return 'Email address is not valid';
    }
  }
  // check for object and primitives
  if (!Array.isArray(value)) {
    const email = value.email ? value.email.trim() : value.trim();
    const isValid = !!isValidEmailAddress(email);

    if (!isValid) {
      return 'Email address is not valid';
    }
  }
  return undefined;
};

export const requiredNonHtmlOnly = (html) =>
  new DOMParser().parseFromString(html, 'text/html').documentElement.textContent
    ? undefined
    : 'Required';
